<!-- eslint-disable vue/valid-v-model -->
<template>
  <div id="modalStartDraw" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" @click="close"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title">{{ $t("map.DrawContour.popup.title") }}</h4>
        </div>
        <div class="modal-body">
          <h5 style="margin-top: 0px">{{ $t('map.DrawContour.popup.labelSelectType') }}</h5>
          <DxSelectBox
            v-model:value="type"
            :data-source="[
              { name: $t('map.DrawContour.popup.labelSelectProject'), value: 'project' },
              { name: $t('map.DrawContour.popup.labelSelectSublocation'), value: 'subLocation' }
            ]"
            display-expr="name"
            value-expr="value"
          />
          <div v-if="type === 'subLocation'" class="dropdown">
            <h5>{{ $t('map.DrawContour.popup.labelSelectSublocation') }}</h5>
            <DxSelectBox v-model:value="SelectedSubLocationGuid" :data-source="sublocations" display-expr="SlName" value-expr="SlGuid" />
          </div>
          <h5>{{ $t('map.DrawContour.popup.labelAction') }}</h5>
          <div class="btn-group">
            <button id="btnActionPaste" type="button" class="btn" :class="{ active: action === 'paste' }" @click="action = 'paste'">{{ $t('map.DrawContour.popup.buttonPaste') }}</button>
            <button id="btnActionDraw" type="button" class="btn" :class="{ active: action === 'draw' }" @click="action = 'draw'">{{ $t('map.DrawContour.popup.buttonDraw') }}</button>
          </div>
          <div v-if="action === 'paste'">
            <h5>{{ $t('map.DrawContour.popup.labelWKT') }}</h5>
            <textarea id="txtWKTString" v-model="wktString" class="form-control" rows="4" :placeholder="$t('map.DrawContour.popup.placeholderWKT')"></textarea>
            <p v-if="wktString.trim().length > 0 && !isWktValid" class="wkt-invalid">{{ $t('map.DrawContour.popup.wktInvalid') }}</p>
            <h5>{{ $t('map.DrawContour.popup.labelCoordinateSystem') }}</h5>
            <DxSelectBox v-model:value="selectedEpsg" :data-source="coordinateSystems" display-expr="name" value-expr="epsg" />
          </div>
        </div>
        <div class="modal-footer">
          <!-- Can only be started with either SubLocation or Project selected -->
          <button v-if="action === 'draw'" id="btnCreateProject" type="button" class="btn" :disabled="SelectedSubLocationGuid.length === 0 && type === 'subLocation'" @click="start">{{ $t('map.DrawContour.popup.buttonStart') }}</button>
          <button v-else id="btnSaveContour" type="button" class="btn" :disabled="!canSave" @click="save">{{ $t('map.DrawContour.popup.buttonSave') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { bus } from '@/bus.js'
import DxSelectBox from 'devextreme-vue/select-box'
import projectionUtil from '@/utils/projectionUtil'

export default {
  name: 'start-draw-modal',
  components: {
    DxSelectBox
  },
  props: {
    drawSource: {
      type: Object
    }
  },

  data() {
    return {
      loading: false,
      type: 'project',
      SelectedSubLocationGuid: '',
      action: 'draw',
      wktString: '',
      selectedEpsg: 'EPSG:28992'
    }
  },

  computed: {
    sublocations() {
      return this.$store.state.subLocations || []
    },

    coordinateSystems() {
      return projectionUtil.coordinateSystems
    },

    /**
     * Validate the pasted WKT string:
     * - must be a POLYGON or LINESTRING
     * - equal amount of opening and closing parentheses
     * - no more decimal points than 2 per coordinate pair (whole numbers are allowed)
     * - every coordinate is a numeric pair
     * - enough coordinates for the geometry type (LINESTRING at least 2, POLYGON at least 3)
     */
    isWktValid() {
      const wkt = this.wktString.trim()
      if (!/^(POLYGON|LINESTRING)\s*\(/i.test(wkt)) return false

      const openCount = (wkt.match(/\(/g) || []).length
      const closeCount = (wkt.match(/\)/g) || []).length
      if (openCount === 0 || openCount !== closeCount) return false

      const commaCount = (wkt.match(/,/g) || []).length
      const dotCount = (wkt.match(/\./g) || []).length
      if (dotCount > 2 * (commaCount + 1)) return false

      const coordinates = wkt.substring(wkt.indexOf('('), wkt.lastIndexOf(')')).replace(/[()]/g, '').split(',')
      const minimumCoordinates = /^LINESTRING/i.test(wkt) ? 2 : 3
      if (coordinates.length < minimumCoordinates) return false

      return coordinates.every((coordinate) => {
        const parts = coordinate.trim().split(/\s+/)
        return parts.length === 2 && parts.every((part) => part !== '' && isFinite(Number(part)))
      })
    },

    canSave() {
      return this.isWktValid && !(this.type === 'subLocation' && this.SelectedSubLocationGuid.length === 0)
    }
  },

  mounted() {
    bus.$on('startDrawEvent', function () {
      $('#modalStartDraw').show()
    })
  },

  methods: {
    setSublocations() {
      this.$store.dispatch('getSubLocations', { projectId: this.$route.params.projectId }).then((result) => {
        this.sublocations = result
      })
    },

    close() {
      this.SelectedSubLocationGuid = ''
      this.wktString = ''
      $('#modalStartDraw').hide()
    },

    start() {
      $('#modalStartDraw').hide()

      this.$emit('startConfirmedDraw', true, { type: this.type, location: this.SelectedSubLocationGuid })
      this.name = ''
    },

    save() {
      $('#modalStartDraw').hide()

      this.$emit('pasteConfirmedContour', { type: this.type, location: this.SelectedSubLocationGuid, wkt: this.wktString.trim(), epsg: this.selectedEpsg })
      this.wktString = ''
    }
  }
}
</script>

<style scoped lang="less">
.btn-group .btn:not(.active) {
  opacity: 0.6;
}

.wkt-invalid {
  color: #a94442;
  margin: 5px 0 0 0;
}
</style>
